import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchRegisterMyApp, deleteMyAppInAppInfoList, getAllMyAppsListInfo } from './serviceThunk';
import * as thunk from './serviceThunk';
import { IAPPResponse } from '@models/scraperModel/appModel';
import { IResponseRegisteredAppInfo, IAllMyAppListObj } from '@models/manager/service/serviceModel';
import { getLocaleValueForFlag } from '@utils/common/language';

const initialState = {
  //myAppInfoList 는 내가 등록한 앱 리스트. (myAppInfoList.includes(selectedApp) 에서 사용예정)
  myAppInfoList: null as IResponseRegisteredAppInfo[],
  // myAppInfo는 현재 내가 등록한 앱 중 선택한 앱. (등록시에만 사용할 것) registerd~로 변수명 바꾸기
  myAppInfo: null as IResponseRegisteredAppInfo, // TODO: 여기 바꿔주기
  // competitorInfo는 현재 내가 등록한 경쟁자 앱리스트 (등록시만 사용!!) registerd~로 변수명 바꾸기
  competitorInfo: null as IResponseRegisteredAppInfo[],
  // myAppInfo + MyCompetitorInfo 합쳐진 앱 정보들
  allMyAppListInfo: null as IAllMyAppListObj[],
  // AppManager - addMyApp 에서 설정한 국가 -> addCompetitorApps 에서 검색시 사용
  countryCode: getLocaleValueForFlag() as string | null,
  // competitorApps 4개 이상 등록시 에러 메시지 등록 / 정상일땐 null
  competitorError: null as string | null,
};

export const serviceSlice = createSlice({
  name: 'serviceManager',
  initialState: initialState,
  reducers: {
    // TODO: (삭제예정) myAppInfoList 의 앱데이터풀데이터 에서 1개 선택시 myAppInfo 에 들어가는 로직임..
    // 세부정보도 디비에서 가져오는걸로 교체해야함.. G_STAR
    setCurrentSelectedMyApp: (state, { payload }: { payload: { myAppInfo: any } }) => {
      state.myAppInfo = payload.myAppInfo;
    },
    // TODO: (삭제처리) 기존의 appListPopup에 들어간 부분 layout 으로 변경처리후 아래는 삭제처리
    setCurrentCompetitorApps: (state, { payload }: { payload: { competitorAppsInfo: any } }) => {
      state.competitorInfo = payload.competitorAppsInfo;
    },
    // AppManager - addMyApp 에서 설정한 국가 -> addCompetitorApps 에서 검색시 사용
    setCountryCode: (state, { payload }: { payload: { countryCode: string } }) => {
      state.countryCode = payload.countryCode;
    },
    // competitorApps 4개 이상 등록시 에러 메시지 등록
    setErrorCompetitorApps: (state, { payload }: { payload: { message: string | null } }) => {
      state.competitorError = payload.message;
    },
  },
  extraReducers: {
    // MyApp 등록 시 사용
    [fetchRegisterMyApp.fulfilled.type]: (state, { payload }) => {
      state.myAppInfo = payload;
    },
    // [DELETE]
    // myAppInfoList 목록 중 MyApp 삭제 시
    [thunk.deleteMyAppInAppInfoList.fulfilled.type]: (
      state,
      action: PayloadAction<{ appId: string; providerType: string; userId: string }>
      // 제대로 데이터를 가져올때
    ) => {
      const { payload } = action;
      // AppManager MyAppList 중 1개 삭제
      state.allMyAppListInfo = state.allMyAppListInfo.filter((item) => {
        let decision = true;
        //@ts-ignore
        if (item.myAppInfo.appId === payload.appId && item.myAppInfo.providerType === payload.providerType) {
          decision = false;
        }
        return decision;
      });
    },
    [thunk.deleteMyAppInAppInfoList.rejected.type]: (
      state,
      action: PayloadAction<{ result: boolean; message: string }>
    ) => {
      // axios DB 요청에서 200이 아닌 다른 상태로 응답 받을때
      // 다른 에러도 처리해야함..
      const { payload } = action;
    },
    // allMyAppListInfo 목록 요청 후 가져오기
    [thunk.getAllMyAppsListInfo.fulfilled.type]: (state, action: PayloadAction<IAllMyAppListObj[]>) => {
      const { payload } = action;
      state.allMyAppListInfo = payload;
    },
    [thunk.getAllMyAppsListInfo.rejected.type]: (state) => {
      // 에러처리 로직..
    },
  },
});

export const { setCurrentSelectedMyApp, setCurrentCompetitorApps, setCountryCode, setErrorCompetitorApps } =
  serviceSlice.actions;
export const serviceSliceName = serviceSlice.name;
export default serviceSlice.reducer;
